export function getRecentSelectedRankingCategoryTabId() {
  return (
    window.localStorage.getItem(
      LOCAL_STORAGE_KEY_RECENT_SELECTED_RANKING_CATEGORY_TAB_ID
    ) || undefined
  );
}

export function saveRecentSelectedRankingCategoryTabId(id: string) {
  window.localStorage.setItem(
    LOCAL_STORAGE_KEY_RECENT_SELECTED_RANKING_CATEGORY_TAB_ID,
    id
  );
}

const LOCAL_STORAGE_KEY_RECENT_SELECTED_RANKING_CATEGORY_TAB_ID =
  'recentSelectedRankingCategoryTabId';
